import { REDUX_ACTIONS, GAME_ID } from 'a/wordSlide/data/constants';
import { getCurriculumQuestionCount } from 'a/wordSlide/redux/selectors/curriculumSelectors';

const initState = {
  levelId: 0,
  questionIndex: 0,
  practiceIndex: 0,
  practiceWasIncorrect: false,
  correctWithSpecialCellInRow: 0,
  totalCorrect: 0,
  progress: 0,
  onboardingsPlayed: [],
  isComplete: false,
};

const questionReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL: {
      const { levelId } = payload;
      return {
        ...state,
        levelId,
        correctWithSpecialCellInRow: 0,
        totalCorrect: 0,
        progress: 0,
        isComplete: false,
      };
    }

    case REDUX_ACTIONS.SET_QUESTION: {
      const { questionIndex } = payload;
      return {
        ...state,
        questionIndex,
        practiceIndex: 0,
        practiceWasIncorrect: false,
      };
    }

    case REDUX_ACTIONS.RESET_CORRECT_WITH_SPECIAL_CELL_IN_ROW:
      return {
        ...state,
        correctWithSpecialCellInRow: 0,
      };

    case REDUX_ACTIONS.INCREASE_CORRECT_WITH_SPECIAL_CELL_IN_ROW:
      return {
        ...state,
        correctWithSpecialCellInRow: state.correctWithSpecialCellInRow + 1,
      };

    case REDUX_ACTIONS.INCREASE_CORRECT_ANSWERS_COUNT:
      return {
        ...state,
        totalCorrect: state.totalCorrect + 1,
      };

    case REDUX_ACTIONS.GET_NEXT_PRACTICE_ITEM:
      return {
        ...state,
        practiceIndex: state.practiceIndex + 1,
      };

    case REDUX_ACTIONS.SET_PRACTICE_WAS_INCORRECT:
      return {
        ...state,
        practiceWasIncorrect: true,
      };

    case REDUX_ACTIONS.INCREASE_PROGRESS: {
      const step = 100 / getCurriculumQuestionCount(state.levelId);
      return {
        ...state,
        progress: state.progress + step,
      };
    }

    case REDUX_ACTIONS.SET_IS_ONBOARDING_COMPLETED:
      return {
        ...state,
        onboardingsPlayed: [
          ...state.onboardingsPlayed,
          payload.contentType,
        ],
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const num = getCurriculumQuestionCount(state.levelId);
      const numCorrect = payload ? num : 0;
      return {
        ...state,
        totalCorrect: numCorrect,
        questionIndex: num - 1,
        progress: num,
      };
    }

    case REDUX_ACTIONS.SET_ROUND_IS_COMPLETE:
      return {
        ...state,
        isComplete: true,
      };

    default:
      return state;
  }
};

export default questionReducer;
